<template>
    <div>
        <header>
            <el-row type="flex" justify="center">
                <el-col :span="4">
                    <router-link to="/">
                        <img src="https://seed-static.seedasdan.com/wordpress/2024/09/aseeder-logo-new.png?x-oss-process=image/resize,m_fill,w_160,h_48"/>
                    </router-link>
                </el-col>
                <el-col :span="18" class="mt-20 text-right">
                    <el-badge :value="NotificationCount" class="mr-40" v-if="this.Role != 'admin'">
                        <router-link to="/notification" target="_blank" class="dark">
                            <i class="el-icon-message"></i>
                        </router-link>
                    </el-badge>
                    <el-dropdown trigger="hover" @command="handleCommand">
                    <span class="el-dropdown-link">
                        Hello {{ LoginName }} <i class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown">
<!--                            <el-dropdown-item class="font-eeSmall" command="edit" v-if="this.Role != 'admin'"><i class="el-icon-edit mr-10"></i>Profile-->
<!--                            </el-dropdown-item>-->
                            <el-dropdown-item class="font-eeSmall" command="password" v-if="this.Role == 'student'"><i class="icon ion-unlocked mr-10"></i> Change Password
                            </el-dropdown-item>
                            <el-dropdown-item class="font-eeSmall" command="logout"><i class="icon ion-log-out mr-10"></i>
                                Log out
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </header>

        <!--修改密码弹窗-->
        <el-dialog title="Change Password" :visible.sync="changePassDialog" customClass="dialogStyle">
            <el-form :model="passform" :rules="changePassRules" ref="passform" label-width="145px">
                <el-form-item label="Current Password" prop="oldPwd">
                    <el-input type="password" v-model="passform.oldPwd" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="New Password" prop="newPwd">
                    <el-input type="password" v-model="passform.newPwd" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changePassDialog = false">Cancel</el-button>
                <el-button type="primary" @click="submitPass('passform')" :loading="changeSaveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>
        <!--学生／老师 修改用户信息-->
        <el-dialog title="Edit User" :visible.sync="editDialog" customClass="dialogStyle">
            <el-form :model="editform" :rules="editrules" v-loading="profileLoading" ref="editform" label-width="145px">
                <el-form-item label="Email Address" prop="email">
                    <el-input placeholder="Email Address" v-model="editform.email"></el-input>
                </el-form-item>
                <el-form-item label="Given Name" prop="givenName">
                    <el-input v-model="editform.givenName" placeholder="Given Name"></el-input>
                </el-form-item>
                <el-form-item label="Family Name" prop="familyName">
                    <el-input v-model="editform.familyName" placeholder="Family Name"></el-input>
                </el-form-item>
                <el-form-item label="Display Name" prop="displayName">
                    <el-input v-model="editform.displayName" placeholder="Display Name"></el-input>
                </el-form-item>
                <el-form-item v-if="this.Role ==='student'" label="Affiliation" prop="school">
                    <el-input v-model="editform.school" placeholder="Affiliation"></el-input>
                </el-form-item>
                <el-form-item label="Mobile Phone" prop="mobilePhone">
                    <el-input v-model="editform.mobilePhone" placeholder="Mobile Phone"></el-input>
                </el-form-item>
                <el-form-item v-if="this.Role == 'student'" label="Father Phone" prop="fatherPhone">
                    <el-input v-model="editform.fatherPhone" placeholder="Father Phone"></el-input>
                </el-form-item>
                <el-form-item v-if="this.Role == 'student'" label="Mother Phone" prop="motherPhone">
                    <el-input v-model="editform.motherPhone" placeholder="Mother Phone"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialog = false">Close</el-button>
                <el-button type="primary" @click="submitedit('editform')" :loading="editSaveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import md5 from '../../component/md5'
    export default {
        // 不加name有可能按照文件名被加载为header组件，导致和模板利用的原生header重名，被认为是递归引用
        name:'common-header',
        data() {
            return {
                LoginName: decodeURI(Cookies.get('name')),//登录用户名
                LoginId: Cookies.get('userid'),//登录用户Id
                StudentId: Cookies.get('studentId'),//学生studengId
                TeacherId: Cookies.get('teacherId'),//老师teacherId
                Role: Cookies.get('role'),//登录用户身份

                NotificationCount: 0,
                //修改用户信息弹窗

                // loading过渡状态变量
                loading: false,
                profileLoading:false,
                editSaveBtnIsLoading: false,
                changeSaveBtnIsLoading: false,

                formLabelWidth: '130px',
                editDialog: false,
                editform: {},
                editrules: {
                    email: [
                        {required: true, message: 'Email Adress Required', trigger: 'blur'},
                        {type: 'email', message: 'Email format invalid.'},
                    ],
                    givenName: [
                        {required: true, message: 'GivenName Required', trigger: 'blur'},
                        {max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur'}
                    ],
                    familyName: [
                        {required: true, message: 'FamilyName Required', trigger: 'blur'},
                        {max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur'}
                    ],
                    displayName: [
                        {required: true, message: 'DisplayName Required', trigger: 'blur'},
                        {max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur'}
                    ],
                    school: [
                        {required: true, message: 'Affiliation Required', trigger: 'blur'},
                        {max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur'}
                    ],
                    mobilePhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    motherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    fatherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ]
                },
                //修改密码
                changePassDialog: false,
                passform: {},
                changePassRules: {
                    oldPwd: [
                        {required: true, message: 'Old Password Required', trigger: 'blur'}
                    ],
                    newPwd: [
                        {required: true, message: 'New Password Required', trigger: 'blur'},
                        {min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur'},
                        {pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur'}
                    ]
                },
            }

        },
        mounted () {
            this.$nextTick(() => {
                // 调用之前判断role是否是管理员，短路用法：&&逻辑与符号左边如果满足条件，不论右边是什么都会直接执行；反之什么也不干。
                if (this.Role !== 'admin' ) {
                    this.getNotificationCount();
                }
            })
        },
        methods: {
            //header部分管理员dropdown操作
            handleCommand(command) {
                if (command === 'logout') {//退出登录
                    var _this = this;
                    this.$http.get('user/logout').then(response => {
                        _this.$router.push('/login');
                    }).catch(error => {
                        // TODO: 精简cookie
                        Cookies.remove('token')
                        Cookies.remove('role')
                        Cookies.remove('name')
                        this.$message.error(error.message)
                    })

                } else if (command === 'edit') {
                    this.editDialog = true;
                    this.editStudent();

                } else if (command === 'password') {
                    this.changePassDialog = true;
                }
            },

            //获取notification总数：教师端/学生端
            getNotificationCount(){
                this.$http.get('notification/count').then(response => {
                    this.NotificationCount = response;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },

            //获取弹窗用户信息
            editStudent(){
                this.profileLoading = true;
                if (this.Role === 'student') {
                    this.$http.get('student/' + this.StudentId).then(response => {
                        this.editform = response;
                        this.profileLoading = false;
                    }).catch(error => {
                        this.$message.error(error.message);
                        this.profileLoading = false;
                    })
                } else if (this.Role === 'teacher' || this.Role === 'ta') {
                    this.$http.get('teacher/' + this.TeacherId).then(response => {
                        this.editform = response;
                        this.profileLoading = false;
                    }).catch(error => {
                        this.$message.error(error.message);
                        this.profileLoading = false;
                    })
                }
            },

            //编辑用户：教师／学生端
            submitedit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.editSaveBtnIsLoading = true;
                        if(this.Role === 'student'){
                            this.$http.put('student', {
                                id: this.StudentId,
                                motherPhone: this.editform.motherPhone,
                                fatherPhone: this.editform.fatherPhone,
                                school: this.editform.school,
                                user: {
                                    email: this.editform.email,
                                    familyName: this.editform.familyName,
                                    givenName: this.editform.givenName,
                                    displayName: this.editform.displayName,
                                    mobilePhone: this.editform.mobilePhone,
                                }
                            }).then(response => {
                                //渲染数据
                                this.editDialog = false;
                                this.loading = false;
                                this.editSaveBtnIsLoading = false;
                                this.$message.success('Edit success');
                            }).catch(error => {
                                this.editDialog = false;
                                this.loading = false;
                                this.editSaveBtnIsLoading = false;
                                this.$message.error(error.message)
                            })
                        }
                        else {
                            this.$http.put('teacher', {
                                id: this.TeacherId,
                                user: {
                                    email: this.editform.email,
                                    familyName: this.editform.familyName,
                                    givenName: this.editform.givenName,
                                    displayName: this.editform.displayName,
                                    mobilePhone: this.editform.mobilePhone,
                                }
                            }).then(response => {
                                //渲染数据
                                this.editDialog = false;
                                this.loading = false;
                                this.editSaveBtnIsLoading = false;
                                this.$message.success('Edit success');
                            }).catch(error => {
                                this.editDialog = false;
                                this.loading = false;
                                this.editSaveBtnIsLoading = false;
                                this.$message.error(error.message)
                            })
                        }

                    } else {
                        return false;
                    }
                });
            },

            //修改密码：学生端
            submitPass(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.changeSaveBtnIsLoading = true;
                        var oldPassward_md5 = md5.hex_md5(this.passform.oldPwd);
                        var newPassward_md5 = md5.hex_md5(this.passform.newPwd);
                        this.$http.post('user/changePwd', {
                            oldPwd: oldPassward_md5,
                            newPwd: newPassward_md5,
                        }).then(response => {
                            console.log(this.passform.oldPwd);
                            this.changePassDialog = false;
                            this.$message.success('Change Password success');
                            this.passform.oldPwd = ''
                            this.passform.newPwd = ''
                            this.changeSaveBtnIsLoading = false;
                        }).catch(error => {
                            this.changePassDialog = false;
                            this.changeSaveBtnIsLoading = false;
                            this.$message.error(error.message)
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
        watch: {
            $route() {
                if (this.Role !== 'admin' ) {
                    this.getNotificationCount();
                }
            }
        }
    }

</script>

<style>


</style>


// WEBPACK FOOTER //
// Header.vue?77b3c6ef